export const MODAL_TYPE_SAVED_PUZZLES = "saved-puzzles";
export const MODAL_TYPE_RESUME_OR_RESTART = "resume-or-restart";
export const MODAL_TYPE_INVALID_INITIAL_DIGITS = 'invalid-initial-digits';
export const MODAL_TYPE_PASTE = 'paste';
export const MODAL_TYPE_SHARE = 'share';
export const MODAL_TYPE_SETTINGS = 'settings';
export const MODAL_TYPE_CHECK_RESULT = 'check-result';
export const MODAL_TYPE_PAUSED = 'paused';
export const MODAL_TYPE_CONFIRM_RESTART = 'confirm-restart';
export const MODAL_TYPE_CONFIRM_CLEAR_COLOR_HIGHLIGHTS = 'confirm-clear-color-highlights';
export const MODAL_TYPE_CONFIRM_ABANDON = 'confirm-abandon';
export const MODAL_TYPE_SOLVER = 'solver';
export const MODAL_TYPE_HELP = 'help';
export const MODAL_TYPE_HINT = 'hint';
export const MODAL_TYPE_ABOUT = 'about';
export const MODAL_TYPE_QR_CODE = 'qr-code';
export const MODAL_TYPE_FEATURES = 'features';
export const MODAL_TYPE_ARCHIVED_PUZZLE = 'archived-puzzle';
export const MODAL_TYPE_CONFIRM_DESIGN_START = 'confirm-design-start';

